<template>
  <div class="game-title-wrapper" :style="`left:${pos.x}%;top:${pos.y}%;width:${width}px;height:${height}px;`">
    <div
      v-if="titleData"
      class="text-style"
      :style="{
        textAlign: 'left',
        marginTop: '6px',
        alignSelf: 'flex-start',
        marginBottom: showIcon && !additionalLine ? '-40px' : '0',
      }"
    >
      <span v-html="titleData"> </span>
      <svg
        style="left: 363px; top: 7px; position: absolute"
        v-if="showIcon"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        id="body_1"
        width="30"
        height="40"
      >
        <g transform="matrix(1.3333334 0 0 1.3333334 0 0)">
          <image
            x="0"
            y="0"
            xlink:href="data:image/png;base64,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"
            preserveAspectRatio="none"
            width="22.5"
            height="30"
          />
        </g>
      </svg>
    </div>
    <div class="new-line left" :class="{ 'padding-top': multiStage }">
      <div class="audio" v-show="audio != ''" style="min-width: 57px; pointer-events: auto; z-index: 1006">
        <!-- <div class="audio-icon"><span>mp3</span></div> -->
        <div
          style="width: 100%; height: 100%; position: relative; cursor: pointer"
          v-if="aduioOn"
          @mouseenter="hoverOnIcon = true"
          @mouseleave="hoverOnIcon = false"
        >
          <img
            :src="aduioOn"
            style="width: 100%; height: 100%; position: absolute"
            v-if="!audioStatus && !hoverOnIcon"
            @click="startPlay()"
          />
          <img
            :src="aduioOnHover"
            style="width: 100%; height: 100%; position: absolute"
            v-if="!audioStatus && hoverOnIcon"
            @click="startPlay()"
          />
          <img
            :src="aduioOff"
            style="width: 100%; height: 100%; position: absolute"
            v-if="audioStatus && !hoverOnIcon"
            @click="startPlay()"
          />
          <img
            :src="aduioOffHover"
            style="width: 100%; height: 100%; position: absolute"
            v-if="audioStatus && hoverOnIcon"
            @click="startPlay()"
          />
        </div>
        <svg class="audio-svg-button" @click="startPlay()" viewBox="0 0 24 24" v-if="!aduioOn">
          <transition name="click-fade">
            <path
              v-if="!audioStatus"
              d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
            />
          </transition>
          <transition name="click-fade">
            <path
              v-if="audioStatus"
              d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
            />
          </transition>
        </svg>
        <!-- <font-awesome-icon :icon="icon" size="2x"></font-awesome-icon> -->
      </div>
      <div>
        <div class="text-style" :style="[audio != '' ? { 'max-width': '1600px' } : {}]">
          <span v-html="titleText"></span>
        </div>
      </div>
    </div>
    <div class="new-line left" v-if="additionalLine" :class="{ 'padding-top': multiStage }">
      <div class="text-style" :style="[audio != '' ? { 'max-width': '1600px' } : {}]">
        <span v-html="additionalLine"></span>
      </div>
    </div>
    <div
      class="new-line left"
      :style="getCustomStyle(additionalLineImage.cssStyle)"
      v-if="additionalLineImage.path"
      :class="{ 'padding-top': multiStage }"
    >
      <div class="text-style" :style="[audio != '' ? { 'max-width': '1600px' } : {}]">
        <img
          v-if="additionalLineImage.path"
          :src="giveMeImagePlease(additionalLineImage.path)"
          :style="{ width: '100%', height: '100%' }"
        />
      </div>
    </div>

    <div class="new-line multi-progress" v-if="multiStage && !gameobj.withoutProgress">
      <!-- <b-progress :value="stageProgress" class="full-width"></b-progress> -->
      <div class="bar-grey"></div>
      <div class="bar-circle"></div>
      <div v-for="item in stageLenght" :key="item.id">
        <div :style="{ left: (97 / stageLenght) * item + '%' }" class="bar-circle"></div>
      </div>

      <div :style="{ float: 'left', width: 100 / stageLenght + '%' }" v-for="item in currentStage" :key="item.id">
        <div class="bar-blue"></div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { Howler } from 'howler';
export default {
  name: 'tr-ui-title',
  props: {
    titleText: {
      type: String,
      default: function() {
        return '';
      },
    },
    titleData: {
      type: String,
      default: function() {
        return '';
      },
    },
    additionalLine: {
      type: String,
      default: function() {
        return '';
      },
    },
    additionalLineImage: {
      type: Object,
      default: function() {
        return {};
      },
    },
    multiStage: {
      type: Boolean,
      default: false,
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    audio: {
      type: String,
      default: function() {
        return '';
      },
    },
    width: {
      type: Number,
      default: function() {
        return 1800;
      },
    },
    height: {
      type: Number,
      default: function() {
        return 115;
      },
    },
    pos: {
      type: Object,
      default: function() {
        return { x: 0, y: 0 };
      },
    },
  },
  data: function() {
    return {
      volumeValue: 1,
      sound: null,
      audioStatus: false,
      actualAudio: 0,
      openAudioBox: false,
      aduioOn: null,
      aduioOnHover: null,
      aduioOff: null,
      aduioOffHover: null,
      hoverOnIcon: false,
    };
  },
  mounted() {
    if (this.audio != '') {
      this.setAudioConfig();
      try {
        this.aduioOn = require('../../../../config/audio/index.js').AUDIO_ON;
        this.aduioOnHover = require('../../../../config/audio/index.js').AUDIO_ON_HOVER;
        this.aduioOff = require('../../../../config/audio/index.js').AUDIO_OFF;
        this.aduioOffHover = require('../../../../config/audio/index.js').AUDIO_OFF_HOVER;
      } catch (error) {
        console.log(error);
      }
    }
  },
  methods: {
    getCustomStyle(item) {
      let customStyle = {};
      if (item) {
        if (_.isObject(item)) {
          customStyle = _.mapKeys(item, function(value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    setAudioConfig() {
      this.sound = new Howl({
        src: this.giveMeImagePlease(this.audio),
        autoplay: false,
        loop: false,
        volume: 1,
        onend: () => {
          this.audioStatus = false;
          console.log('end');
        },
        onpause: () => {
          this.audioStatus = false;
          console.log('end');
        },
        onstop: () => {
          this.audioStatus = false;
          console.log('end');
        },
        onplay: () => {
          this.audioStatus = true;
          console.log('sztart');
        },
      });
    },
    startPlay() {
      if (!this.audioStatus) {
        this.sound.play();
        this.canIPlay = false;
        setTimeout(() => {
          this.canIPlay = true;
        }, 500);
      } else {
        this.stopPlay();
      }
    },
    stopPlay() {
      this.sound.stop();
    },
  },
  beforeDestroy() {
    if (this.audio != '') this.stopPlay();
  },
  computed: {
    stageProgress() {
      return ((this.$store.getters.currentStage + 1) / this.$store.getters.stages.length) * 100;
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/sass/iconColor';
@import '~@/assets/sass/titleStyle';
.game-title-wrapper {
  position: absolute;
  display: flex;
  // justify-content: center;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  width: $titleContainerWidth;
  height: $titleContainerHeight;
  font-size: $titleFontSize;
  background-color: $titleBackgroundColor;
  border-radius: $titleContainerBorderRadius;
  padding-left: 40px;
  margin-left: 11px;
  margin-top: 21px;
  .new-line {
    display: flex;
    height: 50%;
    width: 100%;
  }
  .left {
    justify-content: flex-start;
    align-items: center;
    text-align: left;
  }
  .audio {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px;
    // border: solid 1px black;
    border-radius: 50%;
    height: 57px;
    width: 57px;
    color: $secondIconColor;
    background-color: $firstIconColor;
    transition: 0.2s;
    &:hover {
      // background-color: rgb(40, 196, 36);
      color: $firstIconColor;
      background-color: $secondIconColor;
      // .audio-icon {
      //     color: $secondIconColor;
      //     background-color: $firstIconColor;
      // }
    }
    .audio-svg-button {
      width: 100%;
      height: 100%;
      fill: white;
      transition: 0.2s;
      &:hover {
        fill: #00a8ec;
      }
    }
  }
  .padding-top {
    padding-top: 15px;
  }
  .multi-progress {
    width: 100%;
    height: 4%;
    padding-right: 40px;
    .full-width {
      width: 100%;
      height: 100%;
      .progress-bar {
        background-color: grey;
      }
    }
  }
}
// HACK:title hack
/**
 * hack dla scali i przesuniecia z canvasem w cwiczeniach
 * @type {[type]}
 */

.hack-game-title-wrapper {
  transform: translate(-50%, -50%) scale(0.7) !important;
  left: 32.5% !important;
  top: 2% !important;
}
</style>
